<template>
    <DsModal
        :is-open="isOpen"
        show-back
        :title="$t('email.broadcast.steps.replyTo.addCustomModalTitle')"
        size="med"
        @close="modalClose"
        @back="modalClose"
    >
        <template #default>
            <div>
                <div data-qa="customize-the-reply-to-description" class="reply-to-description">
                    {{ $t('email.broadcast.steps.replyTo.addCustomModalDescription') }}
                </div>

                <div>
                    <DsInputField
                        v-model="displayName"
                        class="reply-to-displayName-input"
                        name="errorText"
                        :label="$t('email.broadcast.steps.replyTo.addCustomModalDisplayName')"
                        :submitted="submitted"
                        :invalid="!displayName.length"
                        required
                        autocomplete="no"
                        data-qa="reply-to-display-name"
                    >
                        <template #error>
                            <div v-if="!displayName.length" data-qa="display-name-error">
                                {{ $t('email.broadcast.steps.replyTo.addCustomModalDisplayNameError') }}
                            </div>
                        </template>
                    </DsInputField>

                    <DsInputField
                        v-model="emailAddress"
                        class="username-input"
                        name="errorText"
                        :label="$t('email.broadcast.steps.replyTo.addCustomModalEmailAddress')"
                        required
                        autocomplete="no"
                        :invalid="invalidEmailAddress"
                        :submitted="submitted"
                        data-qa="reply-to-email-address"
                    >
                        <template #error>
                            <div v-if="showEmailAddressError" data-qa="username-error">
                                {{ $t(emailAddressErrorMessageCode) }}
                            </div>
                        </template>
                    </DsInputField>

                    <div>
                        <DsFilledButton
                            class="save-button"
                            @click="save"
                        >
                            {{ $t('global.save') }}
                        </DsFilledButton>
                    </div>
                </div>
            </div>
        </template>
    </DsModal>
</template>

<script>
import { getEmailValue, isValidEmailAddress } from '@/utils/email.util';

export default {
    props: {
        isOpen: Boolean,
    },

    emits: ['close', 'save'],

    data() {
        return {
            displayName: '',
            emailAddress: '',
            showErrors: false,
            submitted: false,
            invalidEmailAddress: false,
        };
    },

    computed: {
        isDisplayNameValid() {
            return !!this.displayName.length;
        },

        isValid() {
            return this.displayName.length && this.emailAddress.length;
        },

        showEmailAddressError() {
            return (!this.emailAddress.length && this.showErrors) || this.invalidEmailAddress;
        },

        emailAddressErrorMessageCode() {
            if (this.invalidEmailAddress) {
                return 'email.broadcast.steps.replyTo.emailAddressErrorInvalid';
            }

            return 'email.broadcast.steps.replyTo.emailAddressError';
        },
    },

    methods: {
        modalClose() {
            this.$emit('close');
        },

        validateEmail(emailAddress) {
            return isValidEmailAddress(emailAddress);
        },

        save() {
            if (!this.isValid) {
                this.submitted = true;
                this.showErrors = true;
            } else if (!this.validateEmail(this.emailAddress.trim())) {
                this.submitted = true;
                this.invalidEmailAddress = true;
            } else {
                this.$emit('save', {
                    name: this.displayName,
                    email: this.emailAddress.trim(),
                    value: getEmailValue({ email: this.emailAddress.trim(), fullName: this.displayName }),
                });

                this.modalClose();
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.reply-to-description {
    margin-bottom: $spacing-200;
}

.reply-to-displayName-input {
    --input-padding-top: 0;
    --input-padding-bottom: 0;
}

.username-input {
    --input-padding-top: 0;
    --input-padding-bottom: 0;
}

</style>
